import { VelatirResponse as IVelatirResponse } from './types';

export class VelatirResponse implements IVelatirResponse {
  public readonly requestId: string;
  public readonly state: 'approved' | 'denied' | 'pending';

  constructor(data: IVelatirResponse) {
    this.requestId = data.requestId;
    this.state = data.state;
  }

  get isApproved(): boolean {
    return this.state === 'approved';
  }

  get isDenied(): boolean {
    return this.state === 'denied';
  }

  get isPending(): boolean {
    return this.state === 'pending';
  }
}